var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLengthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 33V17H11V24.5859L16.0608 19.5251L17.475 20.9393L14.4143 24H35.657L32.5963 20.9393L34.0105 19.5251L39 24.5146V17H40V33H39V25.4854L34.0105 30.4749L32.5963 29.0607L35.657 26H14.4143L17.475 29.0607L16.0608 30.4749L11 25.4141V33H10Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengthIcon);
export default __webpack_public_path__ + "static/media/Length_icon.87d32bc19d9dcfd132494128e40d0da5.svg";
export { ForwardRef as ReactComponent };